<template>
  <el-drawer
    :title="title"
    :visible.sync="drawer"
    destroy-on-close
    :wrapperClosable="false"
    :custom-class="sidebarIsOpen ? 'widthSpecial210' : 'widthSpecial54'"
    :append-to-body="true"
  >
    <el-descriptions class="mx-20-1 bg-#fff pt-40 pr-30" title="报修人信息" :column="2">
      <el-descriptions-item label="所属项目">
        {{ getCommunityName(previewForm.communityId) }}
      </el-descriptions-item>
      <el-descriptions-item label="报修人员">
        {{ previewForm.submitUserName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="房屋编号">
        {{ previewForm.buildingRoomCode || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="联系方式">
        {{ previewForm.submitUserPhone || '-' }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions class="mx-20-1 bg-#fff pr-30" title="工单信息" :column="2">
      <el-descriptions-item label="工单分类">
        {{ previewForm.categoryName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="报修情况">
        <span
          :style="{
            color: getUrgentType(previewForm.urgentType, previewForm.state),
          }"
        >
          {{ dictType('urgentType', previewForm.urgentType) }}
        </span>
      </el-descriptions-item>
      <el-descriptions-item v-if="previewForm.content" label="报修内容">
        {{ previewForm.content }}
      </el-descriptions-item>
      <el-descriptions-item v-if="previewForm.voiceUrl" label="报修语音">
        <div style="display: flex">
          <div class="read-box" @click="getBo(previewForm.voiceUrl)">
            <img src="@/assets/image/bofang.png" alt="" style="width: 16px; height: 16px" />
            <span style="margin-left: 6px">播放语音</span>
          </div>
          <span style="margin-left: 4px; color: #9e9e9e; font-size: 14 px">{{ `${parseInt(previewForm.voiceDuration / 1000)}"` }}</span>
        </div>
      </el-descriptions-item>
      <el-descriptions-item v-if="previewForm.images" label="照片">
        <ElImg v-for="(item, index) in previewForm.images.split(',')" :key="index" :src="item" />
      </el-descriptions-item>
      <el-descriptions-item label="工单来源">
        {{ dictType('distributeSource', previewForm.source) }}
      </el-descriptions-item>
      <el-descriptions-item label="预约时间">
        {{ previewForm.appointmentTime || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="处理期限">
        {{ handleNull(previewForm.specifyFinishTime) }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions v-if="previewForm.isAppraise === 1" class="mx-20-1 bg-#fff pr-30" title="工单评价" :column="2">
      <el-descriptions-item label="评分">
        {{ previewForm.appraiseScore || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="评价内容">
        {{ previewForm.appraiseContent || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="评价时间">
        {{ previewForm.appraiseTime || '-' }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="mx-20-1 bg-#fff pb-27 pr-30">
      <div class="form-Title mx-20-2">工单流转</div>
      <el-table
        ref="multipleTable"
        row-key="id"
        :data="indexThis.worksheetHandleRecordListArr"
        tooltip-effect="light"
        :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }"
      >
        <el-table-column label="序号" type="index" width="50" align="center" />
        <el-table-column label="操作类型" align="center">
          <template slot-scope="scope">
            {{ dictType('handleType', scope.row.handleType) }}
          </template>
        </el-table-column>
        <el-table-column label="操作人" align="center">
          <template slot-scope="scope">{{ scope.row.handleUserName || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作备注" align="center" width="200">
          <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.images">
              <ElImg v-for="(item, index) in scope.row.images.split(',')" :key="index" :src="item" />
            </template>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column label="操作时间" align="center">
          <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
import { getImgUrl } from '@/api/getFile'
export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      dialogImgs: [],
      previewForm: {},
      title: '',
    }
  },
  methods: {
    handleNull(e) {
      if (!e) {
        return '-'
      } else {
        return e.substring(0, 16)
      }
    },
    getUrgentType(val1, val2) {
      if (val2 === 5) return ''
      if (val1 === 1) return '#EA0000'
      if (val1 === 2) return '#FF8F1F'
      if (val1 === 3) return '#00B578'
    },
    init() {
      let state = this.previewForm.state ? '[' + this.enumList.distributeState[this.previewForm.state - 1].label + ']' : ''
      this.title = `工单编号：${this.previewForm.code}${state}`
    },
    getBo(val) {
      let arr = this.originalImage(val)
      const audio = document.createElement('audio')
      audio.setAttribute('src', `${arr}`)
      audio.play()
    },
    originalImage(val) {
      return getImgUrl(val)
    },
  },
}
</script>

<style lang="scss" scoped>
.read-box {
  width: 160px;
  height: 28px;
  border: 1px solid #3d3d3d;
  display: inline-block;
  text-align: center;
  line-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
